var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.asBanner && !!_vm.validationMessage)?_c('Banner',{attrs:{"color":"error","label":_vm.validationMessage,"icon":_vm.icon}}):(!!_vm.validationMessage)?_c('span',{staticClass:"text-error",attrs:{"data-testid":"error-span"}},[_vm._v(_vm._s(_vm.validationMessage))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }